import { Suspense, lazy, useEffect } from "react";
import {
  Routes,
  Route,
  useLocation,
  Navigate,
  matchPath,
} from "react-router-dom";
import { Skeleton, Spin } from "antd";
import { ChatbotProvider } from "./providers/ChatbotContext";
import Chatbot from "./pages/esgrewampmodule/Chatbot/Chatbot";
import Cookies from "js-cookie";
import ProtectedLayout from "./components/layouts/ProtectedLayout";
import PublicLayout from "./components/layouts/PublicLayout";
import AuthProvider from "./providers/AuthProvider";
import { publicRoutes, protectedRoutes } from "./routes";
import { useSelector, useDispatch } from "react-redux";
import { setPermissions, showSessionExpiredModal } from "./redux/slices/authSlice";
import NotFound from "./pages/auth/NotFound";
import RouteFetcher from "./components/RouteFetcher";

const Forbidden = lazy(() => import("./pages/auth/Forbidden"));

const ProtectedRoute = ({ children }) => {
  const { isLoggedIn, isCheckingSession, accessRoutes, permissions, sessionExpired } = useSelector(
    (state) => state.auth
  );
  const dispatch = useDispatch();
  const location = useLocation();

   useEffect(() => {
      const match = location.pathname.match(/^\/cbam\/submitter\/([^/]+)\/form$/);
      if (match) {
        Cookies.set("cbamToken", match[1], { path: "/" });
      }
    }, [location.pathname]);

  let matchedRoute = null;
  for (const route of accessRoutes) {
    const matched = matchPath({ path: route, exact: true}, location.pathname);
  
  

    if (matched) {
      matchedRoute = route;
      break;
    }
  }

  

  useEffect(() => {
    if (matchedRoute) {
      dispatch(setPermissions(matchedRoute?.permitted_actions || []));
    }
  }, [location.pathname, matchedRoute]);

  if (isCheckingSession) return <Spin size="large" style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }} />;
  if (!isLoggedIn) return <Navigate to="/login" replace />;

  if ((!accessRoutes || accessRoutes.length === 0) && sessionExpired !== true) {

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  if(sessionExpired === true){
    dispatch(showSessionExpiredModal())
  }

  return children;
};

const ESGLayoutWithChatbot = ({ children }) => {
  return (
    <>
      {children}
      <ChatbotProvider>
        <Chatbot />
      </ChatbotProvider>
    </>
  );
};

const Router = () => {
  return (
    <AuthProvider>
      <RouteFetcher />
      <Routes>
        {/* Public routes (no auth) */}
        <Route element={<PublicLayout />}>
          {publicRoutes.map((route, i) => (
            <Route
              key={`public-${i}`}
              path={route.path}
              element={
                <Suspense fallback={<Skeleton />}>
                  <route.element />
                </Suspense>
              }
            />
          ))}
        </Route>

        {/* Protected routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <ProtectedLayout />
            </ProtectedRoute>
          }
        >
          {protectedRoutes.map((route, i) => {
            const isESGRoute = route.path.startsWith("/esg");

            return (
              <Route
                key={`protected-${i}`}
                path={route.path}
                element={
                  <Suspense
                    fallback={
                      <Skeleton
                        active
                        style={{ margin: "10px 10px", width: "90vw" }}
                      />
                    }
                  >
                    {isESGRoute ? (
                      <ESGLayoutWithChatbot>
                        <route.element />
                      </ESGLayoutWithChatbot>
                    ) : (
                      <route.element />
                    )}
                  </Suspense>
                }
              />
            );
          })}
          {/* Catch-all inside protected layout — unknown path → 404 within layout */}
          <Route
            path="*"
            element={
              <Suspense fallback={<Skeleton active style={{ margin: "10px 10px", width: "90vw" }} />}>
                <Forbidden isUnauthorized={false} />
              </Suspense>
            }
          />
        </Route>

        {/* 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AuthProvider>
  );
};

export default Router;
